import { Box, CircularProgress, Typography } from "@mui/material"

const Loading = ({ sx, ...props }) => {
	return (
		<Box sx={[{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center' }, sx]} {...props}>
			<CircularProgress/>
			<Typography paddingLeft={1}>Carregando...</Typography>
		</Box>
	)
}

export default Loading